'use client';
import React from 'react';
import { X, Search, Heart, Plus, LogIn } from 'lucide-react';
import Link from 'next/link';


interface WelcomeModalProps {
  onClose: () => void;
  onDonate: () => void;
  onLogin: () => void;
}

export default function WelcomeModal({ onClose, onDonate, onLogin }: WelcomeModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in-0 zoom-in-95 duration-200"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="relative bg-gradient-to-br from-[#1e5c38] to-[#2d7a4f] px-6 pt-8 pb-6 text-center">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-1.5 rounded-lg text-white/70 hover:text-white hover:bg-white/20 transition-colors"
            aria-label="Close welcome"
          >
            <X size={18} />
          </button>
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">🌿</span>
          </div>
          <h2 className="text-2xl font-bold text-white mb-1">Maligayang Pagdating!</h2>
          <p className="text-white/80 text-sm">
            Maghanap o tumulong sa mga community pantries na malapit sa'yo!
          </p>
        </div>

        {/* Body */}
        <div className="px-6 py-6 space-y-3">
          <p className="text-sm text-[#6b7280] text-center mb-4">
            Ano ang gusto mong gawin ngayon?
          </p>

          {/* Find */}
          <button
            onClick={onClose}
            className="w-full flex items-center gap-4 px-5 py-4 bg-[#f0faf4] hover:bg-[#e8f5ee] border border-[#d1ead9] rounded-xl transition-all active:scale-[0.98] text-left group"
          >
            <div className="w-10 h-10 bg-[#2d7a4f] rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-[#1e5c38] transition-colors">
              <Search size={18} className="text-white" />
            </div>
            <div>
              <p className="font-semibold text-[#1e5c38] text-sm">Find</p>
              <p className="text-xs text-[#9ca3af] mt-0.5">Hanapin ang pantry malapit sa iyo</p>
            </div>
          </button>

          {/* Donate */}
          <button
            onClick={() => { onClose(); onDonate(); }}
            className="w-full flex items-center gap-4 px-5 py-4 bg-[#fff7ed] hover:bg-[#ffedd5] border border-[#fed7aa] rounded-xl transition-all active:scale-[0.98] text-left group"
          >
            <div className="w-10 h-10 bg-[#ea580c] rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-[#c2410c] transition-colors">
              <Heart size={18} className="text-white" />
            </div>
            <div>
              <p className="font-semibold text-[#9a3412] text-sm">Donate</p>
              <p className="text-xs text-[#9ca3af] mt-0.5">Tumulong sa isang community pantry</p>
            </div>
          </button>

          {/* Add a Community Pantry */}
          <Link
            href="/submit-a-pantry"
            onClick={onClose}
            className="w-full flex items-center gap-4 px-5 py-4 bg-[#eff6ff] hover:bg-[#dbeafe] border border-[#bfdbfe] rounded-xl transition-all active:scale-[0.98] text-left group"
          >
            <div className="w-10 h-10 bg-[#2563eb] rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-[#1d4ed8] transition-colors">
              <Plus size={18} className="text-white" />
            </div>
            <div>
              <p className="font-semibold text-[#1e40af] text-sm">Add a Community Pantry</p>
              <p className="text-xs text-[#9ca3af] mt-0.5">Irehistro ang iyong pantry sa mapa</p>
            </div>
          </Link>

          {/* Login */}
          <button
            onClick={() => { onClose(); onLogin(); }}
            className="w-full flex items-center gap-4 px-5 py-4 bg-[#f9fafb] hover:bg-[#f3f4f6] border border-[#e5e7eb] rounded-xl transition-all active:scale-[0.98] text-left group"
          >
            <div className="w-10 h-10 bg-[#374151] rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-[#1f2937] transition-colors">
              <LogIn size={18} className="text-white" />
            </div>
            <div>
              <p className="font-semibold text-[#374151] text-sm">Login</p>
              <p className="text-xs text-[#9ca3af] mt-0.5">Mag-login bilang pantry owner, hub coordinator, o admin</p>
            </div>
          </button>
        </div>

        {/* Footer */}
        <div className="px-6 pb-5 text-center">
          <button
            onClick={onClose}
            className="text-xs text-[#9ca3af] hover:text-[#6b7280] transition-colors underline underline-offset-2"
          >
            Isara at tingnan ang mapa
          </button>
        </div>
      </div>
    </div>
  );
}
